/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';

type IframeProps = {
  id: string;
  testId?: string;
  title?: string;
  size?: { height?: number; width?: number };
  src: string;
  scrolling?: 'auto' | 'yes' | 'no';
};

const defaultProps = {
  testId: 'iframe',
  title: null,
  size: { width: '100%', height: '100%' },
  scrolling: 'auto',
};

// use default 16 for non-browser env (jest)
const remToPixels = (rem: number): number =>
  rem * parseInt(getComputedStyle(document?.documentElement)?.fontSize || '16', 10);

const Iframe = ({ id, testId, title, size, src, scrolling }: IframeProps): JSX.Element => (
  <iframe
    id={`${id}_Iframe`}
    key={src} // ensure remount of iframe
    data-testid={`${testId}-${title}_Iframe`}
    src={src}
    title={title}
    style={{ width: size.width - remToPixels(2), height: size.height - remToPixels(2) }}
    scrolling={scrolling}
  />
);

Iframe.defaultProps = defaultProps;
export default Iframe;
